import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
export const UploaderModalAlert = ({
  onClose,
  text,
  titleText,
  type
}) => {
  if (!text || !titleText) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    marginBlockEnd: "800",
    closeable: true,
    onClose: onClose,
    titleText: titleText,
    type: type,
    children: text
  });
};